// 🎨 TEMA "AZUL MODERNO VIBRANTE" - Discord/GitHub/Notion Style  
export const THEME_TRIBUNAL_MODERNO = {
  // 🔵 Cores principais - Azul moderno e vibrante
  primary: '#2563EB',        // Azul vibrante principal
  primaryLight: '#3B82F6',   // Azul médio brilhante
  primaryDark: '#1D4ED8',    // Azul escuro vibrante

  // ✨ Cores de destaque - Azul neon/elétrico
  gold: '#0EA5E9',           // Azul sky vibrante (substitui dourado)
  goldLight: '#38BDF8',      // Azul sky claro 
  goldDark: '#0284C7',       // Azul sky escuro

  // 🤍 Fundos - Modernos e limpos
  background: '#F8FAFC',     // Cinza muito claro (quase branco)
  surface: '#FFFFFF',        // Branco puro
  surfaceElevated: '#FFFFFF', // Branco para cards elevados
  surfaceHover: '#F1F5F9',   // Cinza claro para hover

  // 📝 Textos - Alto contraste e modernos
  textPrimary: '#0F172A',    // Preto azulado escuro
  textSecondary: '#334155',  // Cinza azulado médio
  textLight: '#64748B',      // Cinza azulado claro
  textContrast: '#FFFFFF',   // Branco para contraste
  textGold: '#0EA5E9',       // Azul sky para destaques

  // 🔲 Bordas - Sutis mas definidas
  border: '#E2E8F0',         // Cinza azulado claro
  borderAccent: '#3B82F6',   // Azul vibrante para destaques
  borderDark: '#CBD5E1',     // Cinza azulado médio
  borderHover: '#2563EB',    // Azul vibrante para hover

  // 🚦 Status - Cores vibrantes e modernas
  success: '#10B981',        // Verde esmeralda vibrante
  successLight: '#34D399',   // Verde claro brilhante
  successBg: '#ECFDF5',      // Fundo verde muito claro

  warning: '#F59E0B',        // Laranja âmbar vibrante
  warningLight: '#FBBF24',   // Laranja claro brilhante
  warningBg: '#FFFBEB',      // Fundo laranja muito claro

  error: '#EF4444',          // Vermelho vibrante
  errorLight: '#F87171',     // Vermelho claro brilhante
  errorBg: '#FEF2F2',        // Fundo vermelho muito claro

  info: '#3B82F6',           // Azul vibrante
  infoBg: '#EFF6FF',         // Fundo azul muito claro

  // 🚨 Cores de urgência - Vibrantes e chamativas
  urgent: '#DC2626',         // Vermelho urgente vibrante
  urgentBg: '#FEF2F2',       // Fundo vermelho claro
  urgentBorder: '#FECACA',   // Borda vermelha

  today: '#DC2626',          // Vermelho para hoje (urgente)
  todayBg: '#FEF2F2',        // Fundo vermelho claro
  todayBorder: '#FECACA',    // Borda vermelha

  thisWeek: '#2563EB',       // Azul vibrante para esta semana
  thisWeekBg: '#EFF6FF',     // Fundo azul claro
  thisWeekBorder: '#BFDBFE', // Borda azul

  normal: '#64748B',         // Cinza azulado para normal
  normalBg: '#FFFFFF',       // Fundo branco
  normalBorder: '#E2E8F0',   // Borda cinza azulada clara

  // 🌈 Gradientes modernos e vibrantes
  gradientPrimary: 'linear-gradient(135deg, #2563EB 0%, #3B82F6 100%)',
  gradientGold: 'linear-gradient(135deg, #0EA5E9 0%, #38BDF8 100%)',
  gradientSurface: 'linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)',
  gradientHero: 'linear-gradient(135deg, #1D4ED8 0%, #2563EB 50%, #3B82F6 100%)',
};

// 📱 Paleta antiga (manter compatibilidade)
export const paletaAzulJuridica = {
  primaria: '#2563EB',        // Azul vibrante
  secundaria: '#3B82F6',      // Azul médio brilhante
  realce: '#0EA5E9',          // Azul sky vibrante
  fundo: '#F8FAFC',           // Cinza muito claro
  textoContraste: '#FFFFFF',  // Branco
  textoNormal: '#0F172A',     // Preto azulado
  borda: '#3B82F6',           // Azul vibrante
  sucesso: '#10B981',         // Verde esmeralda
  erro: '#EF4444',            // Vermelho vibrante
  aviso: '#F59E0B',           // Laranja âmbar
};

// Configurações da aplicação
export const APP_CONFIG = {
  name: 'JurisPrazo',
  description: 'Sistema SaaS para gestão de prazos processuais e comunicações judiciais',
  version: '2.0.0', // Atualizado para v2 com Escavador
  author: 'Fabio Magalhaes',
  
  // URLs da API PJe (Comunica - Gratuita)
  pjeApi: {
    baseUrl: 'https://comunicaapi.pje.jus.br/api/v1',
    comunicacao: '/comunicacao'
  },
  
  // URLs da API Escavador (Paga - Premium)
  escavadorApi: {
    baseUrlV2: 'https://api.escavador.com/v2',
    baseUrlV1: 'https://api.escavador.com/v1',
    docsUrl: 'https://api.escavador.com/v2/docs/',
    // Token configurado em escavadorConfig.js
  },
  
  // Configurações de paginação
  pagination: {
    defaultPageSize: 100,
    maxPageSize: 500
  },
  
  // Configurações de rate limiting
  rateLimit: {
    // PJe API
    pjeApiDelay: 60000, // 1 minuto entre requisições em caso de erro 429
    pjeMaxRetries: 3,
    
    // Escavador API (mais flexível)
    escavadorRequestsPerMinute: 500,
    escavadorMinDelay: 120, // 120ms entre requisições
    escavadorMaxRetries: 3
  },
  
  // Fontes de dados disponíveis
  dataSources: {
    pje: {
      name: 'Comunica PJE',
      type: 'free',
      description: 'API gratuita do PJE para comunicações judiciais',
      coverage: 'Tribunais com sistema PJE'
    },
    escavador: {
      name: 'Escavador API',
      type: 'premium',
      description: 'API completa com dados de todos os tribunais do Brasil',
      coverage: 'Todos os tribunais brasileiros',
      features: [
        'Monitoramento em tempo real (webhooks)',
        'Dados completos do processo',
        'Resumos inteligentes com IA',
        'Download de documentos',
        'Busca por advogado/envolvido'
      ]
    }
  }
};

// Tipos de processo disponíveis
export const TIPOS_PROCESSO = [
  'Cível',
  'Criminal',
  'Trabalhista',
  'Tributário',
  'Administrativo',
  'Consumidor',
  'Família',
  'Sucessões',
  'Contratual',
  'Empresarial',
  'Outros'
];

// Status de processo disponíveis
export const STATUS_PROCESSO = [
  'Em andamento',
  'Pendente Análise',
  'Suspenso',
  'Aguardando Cliente',
  'Aguardando Documentos',
  'Concluído',
  'Arquivado'
];

// Estados brasileiros para OAB
export const ESTADOS_OAB = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 
  'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 
  'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
];
